module.exports = __webpack_public_path__ + "img/success-goal.3f1c07c1.png";